import React, { useState, useEffect, useRef } from 'react';
import './Stats.css';

const Stats = () => {
    const [counts, setCounts] = useState({
        customers: 0,
        services: 0,
        experience: 0,
        professionals: 0
    });

    const statsRef = useRef(null);
    const [hasAnimated, setHasAnimated] = useState(false);

    const stats = React.useMemo(() => [
        { key: 'customers', label: 'Happy Customers', target: 100, suffix: '+' },
        { key: 'services', label: 'Services Done', target: 100, suffix: '+' },
        { key: 'experience', label: 'Years of Experience', target: 4, suffix: '+' }
    ], []);

    const animateStats = React.useCallback(() => {
        stats.forEach((stat) => {
            let current = 0;
            const increment = stat.target / 100;
            const timer = setInterval(() => {
                current += increment;
                if (current >= stat.target) {
                    current = stat.target;
                    clearInterval(timer);
                }
                setCounts((prev) => ({
                    ...prev,
                    [stat.key]: Math.floor(current)
                }));
            }, 20);
        });
    }, [stats]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !hasAnimated) {
                    animateStats();
                    setHasAnimated(true);
                }
            },
            { threshold: 0.3 }
        );

        const currentRef = statsRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [hasAnimated, animateStats]);

    return (
        <section className="stats section" ref={statsRef}>
            <div className="container">
                <div className="stats-grid">
                    {stats.map((stat, index) => (
                        <div className="stat-card" key={index}>
                            <div className="stat-number">
                                {counts[stat.key].toLocaleString()}{stat.suffix}
                            </div>
                            <div className="stat-label">{stat.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stats;